module.exports = __webpack_public_path__ + "img/img-3-5mobile.e1786fb9.png";